// Sanft pulsierende Platzhalter für Ladezustände – wirkt schneller/ruhiger als „Lädt…".
export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-slate-200/70 ${className}`} />;
}

// Ganzseitiger Lade-Platzhalter (Kopf + Listenzeilen) für Suspense-Fallbacks.
export function PageSkeleton() {
  return (
    <div className="px-6 pt-6" aria-busy="true" aria-label="Wird geladen">
      <Skeleton className="h-7 w-56" />
      <Skeleton className="mt-2 h-4 w-80" />
      <div className="mt-6 grid gap-3">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="rounded-2xl border border-slate-200 bg-white/70 p-4">
            <div className="flex items-center justify-between gap-3">
              <Skeleton className="h-5 w-1/3" />
              <Skeleton className="h-8 w-24" />
            </div>
            <Skeleton className="mt-3 h-4 w-2/3" />
          </div>
        ))}
      </div>
    </div>
  );
}
